import { all } from 'redux-saga/effects';
import { userSagas } from './User';
import { dataControlSagas } from './DataControl';

export const rootSaga = function* root() {
  yield all([userSagas(), dataControlSagas()]);
};
